export default __webpack_public_path__ + "static/media/component-info-card.844c4824.png";